<template>
  <div class="main ex">
    <div class="header">
      <a class="backBtn" @click="$router.go(-1)">
        <i class="icon_back"></i> {{ $t('back') }}
      </a>
    </div>

    <div class="scanBox">
      <div class="scanTopBox"></div>
      <div class="scanTitie">{{ $t('scanPage.scanTitie') }}</div>
      <div class="scanLineBox">
        <qrcode-stream class="qrscanner" @decode="onDecode" @init="onInit"></qrcode-stream>
      </div>
      <div class="scanLineBoxBorder"></div>
      <div class="scanBottomBox"></div>
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import { mapActions } from 'vuex'

export default {
  components: { QrcodeStream },
  data() {
    return {
      error: '',
    }
  },
  methods: {
    ...mapActions([
      'trackerLog',
    ]),
    onDecode(url) {
      if (!url) return
      const codeArr = url.split('/')
      const code = codeArr[codeArr.length - 1]
      if (code) {
        this.clearStorage()
        this.$GuideAPI.getNavigation(code).then((res) => {
          if (res.data.PROJECTCODE && res.data.QRCODE && res.data.GUIDEREPERTOIR && res.data.PROJECTINFO) {
            localStorage.setItem('projectCode', res.data.PROJECTCODE)
            localStorage.setItem('qrcode', res.data.QRCODE)
            localStorage.setItem('guideRepertoire', JSON.stringify(res.data.GUIDEREPERTOIRE))
            localStorage.setItem('projectInfo', JSON.stringify(res.data.PROJECTINFO))
            this.trackerLog({
              event: 'scan_succeed',
              message: {
                projectCode: res.data.PROJECTCODE,
                qrcode: res.data.QRCODE,
              },
            })
            this.$router.push({ name: 'Exhibition' })
          } else {
            if (!res.data.PROJECTCODE) this.scanFailTracker('PROJECTCODE', code)
            if (!res.data.QRCODE) this.scanFailTracker('QRCODE', code)
            if (!res.data.GUIDEREPERTOIR) this.scanFailTracker('GUIDEREPERTOIR', code)
            if (!res.data.PROJECTINFO) this.scanFailTracker('PROJECTINFO', code)
            this.$alert.errorAlert(this.$t('scanPage.scanError'))
          }
        }).catch((err) => {
          console.error(err)
          this.$alert.errorAlert(this.$t('scanPage.scanError'))
          this.trackerLog({
            event: 'scan_faild',
            message: {
              err,
            },
          })
        })
      }
    },
    clearStorage() {
      localStorage.removeItem('projectCode')
      localStorage.removeItem('qrcode')
      localStorage.removeItem('guideRepertoire')
      localStorage.removeItem('projectInfo')
    },
    async onInit(promise) {
      try {
        await promise
      } catch (error) {
        this.error = this.$t('scanPage')[error.name]
        this.$alert.errorAlert(this.error)
      }
    },
    scanFailTracker(field, code) {
      const userInfo = localStorage.getItem('userInfo')
      const { uid } = JSON.parse(userInfo)
      this.trackerLog({
        event: 'scan_faild',
        message: {
          code,
          uid,
          failReason: `${field} is empty`,
        },
      })
    },
  },
}
</script>

<style>
</style>
